import React, { useEffect, useState } from 'react';
import { withSnackbar } from 'notistack';
import { ScreenTitle } from '../../../../components/atoms';
import LoadingModal from '../../../../components/atoms/LoadingModal';
import './style.scss';
import { getNameInitials } from '../../../../shared/services/Utility';
import LeaderboardListView from './LeaderboardListView';

const Leaderboard = ({
  state,
  userId,
  sessionToken,
  loading,
  fetchLeaderboardDetails,
  enqueueSnackbar,
}) => {
  const [leaderboard_showCompnany, set_leaderboard_showCompany] = useState(
    true,
  );
  const [leaderboard_allData, set_leaderboard_allData] = useState([]);
  const [leaderboard_companyData, set_leaderboard_companyData] = useState([]);
  const [userName, set_username] = useState('');
  // const [user_Id, set_user_id] = useState("");
  const [userRank_company, set_userRank_company] = useState(1);
  const [userRank_all, set_userRank_all] = useState(1);
  const [userScore, set_userScore] = useState(0);

  const fetchData = () => {
    fetchLeaderboardDetails(
      {
        userId,
        sessionToken,
      },
      (message, type) => {
        if (type !== 'success') {
          enqueueSnackbar(message, {
            variant: type,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        }
      },
    );
    if (state.DashBoardReducer.leaderBoardData.length > 0) {
      /* update data to be shown in challenge screen */
      let data = state.DashBoardReducer.leaderBoardData;
      data.sort((a, b) => b.highestScore - a.highestScore);
      set_leaderboard_allData(data);

      /* update userdata */
      let companyName = '';
      data.forEach((data, index) => {
        if (data.userId === userId) {
          companyName = data.companyName;
          set_username(data.userName);
          // set_user_id(data.userId);
          set_userScore(data.highestScore);
        }
      });

      /* filter leaderboard data company wise */
      let company_data = state.DashBoardReducer.leaderBoardData.filter(
        (val) => val.companyName === companyName,
      );
      set_leaderboard_companyData(company_data);

    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    updateRank();
  }, [leaderboard_companyData, leaderboard_allData]);

  /******* st nd rd suffixes ******/
  const ordinal_suffix_of = (i) => {
    var j = i % 10,
      k = i % 100;
    if (j === 1 && k !== 11) {
      return <>{i}<sup>st</sup></>;
    }
    if (j === 2 && k !== 12) {
      return <>{i}<sup>nd</sup></>;
    }
    if (j === 3 && k !== 13) {
      return <>{i}<sup>rd</sup></>;
    }
    return <>{i}<sup>th</sup></>;
  };

  /**** updates user rank *****/
  const updateRank = () => {
    let rank_company = findUserRankInTheList(0);
    let rank_all = findUserRankInTheList(1);
    set_userRank_company(rank_company);
    set_userRank_all(rank_all);
  };

  const findUserRankInTheList = (index) => {
    let data = [];
    let lastRank = 0;
    if (index === 1) {
      data = leaderboard_allData;
      lastRank = data.length;
    } else if (index === 0) {
      data = leaderboard_companyData;
      lastRank = data.length;
    }
    const sorted =
      data &&
      data.sort((item1, item2) => {
        return item2.highestScore - item1.highestScore;
      });
    let userRank = sorted.findIndex((item) => {
      return item.userName === userName;
    });

    /* update user scores */
    if (userRank === -1) {
      set_userScore(0);
      userRank = lastRank;
    } else {
      set_userScore(data[userRank].highestScore);
    }

    /* update user rank */
    // this.state.userRank = ++userRank
    return ++userRank;
  };

  return (
    <>
      <ScreenTitle title='Dashboard' subTitle='Leaderboard'/>
      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : (
        <div className='leaderboard-screen'>
          <div className='leaderboard-details'>
            <div className='leaderboard-info'>
              <div className='leaderboard-position'>
                <span className='info-text'>
                  {/* {"4"}
                <sup>{"th"}</sup> */}
                  {leaderboard_showCompnany
                    ? ordinal_suffix_of(userRank_company)
                    : ordinal_suffix_of(userRank_all)}
                </span>
                <span>POSITION</span>
              </div>
              <div className='leaderboard-name'>
                <span className='trophy-initials'>
                  {getNameInitials(userName).toUpperCase()}
                </span>
                <span className='leaderboard-username'>{userName}</span>
              </div>
              <div className='leaderboard-position'>
                <span className='info-text'>
                  {userScore ? userScore : '0'}%
                </span>
                <span>PERCENTAGE</span>
              </div>
            </div>
          </div>
          <div className='d-flex align-items-center sticky-header'>
            <ul className='d-flex align-items-center card_tab'>
              <li
                style={{
                  ...styless.linkStyle,
                  ...(leaderboard_showCompnany
                    ? { borderBottom: '2px solid #1b3665', color: '#7dbf43' }
                    : null),
                }}
                onClick={() => {
                  set_leaderboard_showCompany(true);
                }}
              >
                Company
              </li>
              <li
                style={{
                  ...styless.linkStyle,
                  ...(!leaderboard_showCompnany
                    ? { borderBottom: '2px solid #1b3665', color: '#7dbf43' }
                    : null),
                }}
                onClick={() => {
                  set_leaderboard_showCompany(false);
                }}
              >
                Global
              </li>
            </ul>
            {/* <h4>Leaderboard Coming soon......</h4> */}
          </div>
          <div className='leaderboard-list-container'>
            <LeaderboardListView
              data={
                leaderboard_showCompnany
                  ? leaderboard_companyData
                  : leaderboard_allData
              }
              userName
              // type={leaderboard_showCompnany ? "company" : "global"}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default withSnackbar(Leaderboard);

const styless = {
  cancelBtnWrapper: {
    position: 'absolute',
    right: 15,
    top: 15,
    cursor: 'pointer',
  },
  cancelIcon: {
    color: '#fff',
    fontSize: 30,
  },
  linkStyle: {
    cursor: 'pointer',
    margin: 15,
    padding: 5,
  },
};
